import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@americanexpress/dls-react';
import { Variant, Experiment } from '@americanexpress/one-experiments';
import { IconCalendar } from '@americanexpress/dls-icons';
import { HOMEPAGE_REDESIGN_EXPERIMENT } from '../../constants/experimentConstant';

const DateInputLabel = ({ inputID, labelID, labelText }) => {
  const variant = (
    <div className="flex flex-align-center margin-1-b">
      <Label id={labelID} htmlFor={inputID} tabIndex="-1">
        {labelText}
      </Label>
    </div>
  );
  return (
    <Experiment
      experimentName={HOMEPAGE_REDESIGN_EXPERIMENT}
      dimensionName="search_widget"
      defaultVariant="control"
    >
      <Variant variant="control">
        <div className="flex flex-align-center">
          <IconCalendar color="neutral" size="sm" role="presentation" />
          <label id={labelID} htmlFor={inputID} tabIndex="-1" className="body color-text-subtle margin-0">
            {labelText}
          </label>
        </div>
      </Variant>
      <Variant variant="widget_a_with_hero">{variant}</Variant>
      <Variant variant="widget_a_no_hero">{variant}</Variant>
      <Variant variant="widget_b_with_hero">{variant}</Variant>
      <Variant variant="widget_b_no_hero">{variant}</Variant>
    </Experiment>
  );
};

DateInputLabel.propTypes = {
  inputID: PropTypes.string.isRequired,
  labelID: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
};

export default DateInputLabel;
